import { render } from "./ProfileSegurancaTab.vue?vue&type=template&id=ee3fcbd2&scoped=true&ts=true"
import script from "./ProfileSegurancaTab.vue?vue&type=script&lang=ts"
export * from "./ProfileSegurancaTab.vue?vue&type=script&lang=ts"

import "./ProfileSegurancaTab.vue?vue&type=style&index=0&id=ee3fcbd2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3fcbd2"]])

export default __exports__